module.exports = __webpack_public_path__ + "static/gtm-ga4-smilee-tag-fd2852ab844e48b2cca2dc4939a3b241.png";